import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { FiPhoneCall, FiMail } from "react-icons/fi";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when component is mounted
  }, []);
  return (
    <Container>
      <div className="privacy_text">
        <h2>FindMe: Privacy Policy</h2>
        <h4>
          <b>Last Updated :</b> 16 June 2025
        </h4>
        <p>
        Welcome to <b>FindMe!</b> We care about your privacy. This Privacy Policy explains 
        how we collect, use, and protect your personal data while using this mobile 
        app. So, whether you’re looking for a job or hiring workers for your business. 
        By continuing to use the app, you agree to follow the practices mentioned ahead.
        </p>

        <h4>1. Information We Collect</h4>
        <p>
        To help you connect with the right people safely, we collect the following information:
        </p>

        <ul>
          <li>
            <b>Personal Information </b>
            <p> When you create an account, we collect your name, 
            email, phone number, and other profile details. If you’re a company, we may ask 
            for your business name and verification documents.
            </p>
          </li>
          <li>
            <b>Job & Business Details</b> 
            <p>This includes job listings, applications, resumes, skills, 
              business profiles, and other related data.</p>
          </li>
          <li>
            <b>Location Data </b>
            <p>We use your location to help show jobs or candidates near you. You can 
              turn this on or off anytime in your phone’s settings.</p>
          </li>
          <li><b>Media Uploads</b>
          <p>If you upload photos, resumes, or other job-related content, we store 
            that to help others learn more about you or your business.</p>
            </li>
            <li><b>Technical Data</b>
            <p>We collect device information, app activity, IP address, and crash 
              reports to improve app performance and keep it secure.</p>
              </li>
        </ul>

        <h4>2. How We Use Your Information?</h4>
        <p>We use the collected data to:</p>
        <ul>
          <li>
          Help you find job opportunities or connect with workers based on your needs.
          </li>
          <li>
          Make your experience better through our mobile app.
          </li>
          <li>Securing the account and platform for all users.</li>
          <li>Send important notifications, job alerts, and updates.</li>
          <li>Meet legal obligations and respond to requests from authorities if needed.</li>
        </ul>

        <h4>3. OTP & Email Verification</h4>
        <p>You agree to receive one-time passwords (OTPs) through email for secure login and 
          identity verification. These messages are only used for account access.</p>

        <h4>4. User Safety & Reporting</h4>
        <p>We want ‘FindMe’ App to be a safe place for everyone:</p>
        <ul>
          <li>We don’t allow harmful, abusive, or illegal content.</li>
          <li>Users can report inappropriate behavior or content directly in the app.</li>
          <li>Any violations will lead to account suspension or removal, and we may have 
            to contact legal authorities also if necessary.</li>
        </ul>

        <h4>5. Sharing Your Information</h4>
        <p>
        We do not sell your personal information. However, we may share certain data with:
        </p>
        <ul>
          <li>Trusted services (like location and identity verification) that help run the app smoothly.</li>
          <li>Legal authorities, if required to do so by law.</li>
        </ul>
        <h4>6. Cookies & Tracking Tools</h4>
        <p>
        At <b>‘FindMe’</b>, may use cookies or similar tools to:
        </p>

        <ul>
          <li>Save your preferences and login info.</li>
          <li>Understand how the app is used and improve features.</li>
          <li>Show relevant content based on your activity.</li>
        </ul>

        <h4>7. Data Security </h4>
        <p>
        We strongly use safety methods to protect your data of users. 
        But, while no system is 100% secure, we take every suitable 
        step to keep your information safe.
        </p>

        <h4>8. Your Rights & Controls</h4>
        <p>
        You can:
        </p>

        <ul>
          <li>
          Edit or delete your personal details anytime.
          </li>
          <li>
          Manage your location and notification settings through your phone.
          </li>
          <li>
          You can contact our support team if you need help with your data or account.
          </li>
        </ul>

        <h4>9. Third-Party Services</h4>
        <p>
        If you use links or features that redirect you to other apps, their privacy 
        rules will apply. We are not responsible for how other apps or services use your data.
        </p>

        <h4>10. Policy Updates  </h4>
        <p>
        We may update this policy from time to time. Changes will be shown inside the 
        app, and using the app after updates means you accept the new terms.
        </p>

        <div className="contact-section-box">
          <h4>11. Contact Us</h4>
          <p className="contact-subtitle">
            Have questions or concerns? Contact us anytime or reach out to us at:
          </p>

          <div className="contact-cards-grid">
            <a href="tel:3432977008" className="contact-card-item">
              <div className="contact-icon-wrapper">
                <FiPhoneCall />
              </div>
              <div className="contact-info">
                <span className="contact-label">Call Us</span>
                <span className="contact-value">+13432977008</span>
              </div>
            </a>

            <a href="mailto:admin@findmeweb.com" className="contact-card-item">
              <div className="contact-icon-wrapper">
                <FiMail />
              </div>
              <div className="contact-info">
                <span className="contact-label">Email Us</span>
                <span className="contact-value">admin@findmeweb.com</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PrivacyPolicy;
